/* eslint-disable eqeqeq */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useState } from "react";
import { fa_currency } from "../../utils/Persian";

function Price({data}:any) {
    const [expandedCards, setExpandedCards] = useState<Record<number, boolean>>({});

    return ( 
        <div className="container-fluid wow fadeInUp" id="pricing" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: "600px"}}>
                    <h5 className="fw-bold text-danger text-uppercase">پـرمـیـــوم شــویـــــد</h5>
                    <h1 className="mb-0">با تهیه اشتراک از تمامی امکانات و منابع استفاده نمایید</h1>
                </div>
                <div className="row g-0">
                    {data && data.map((row:any,index:number) => {
                        return (() => {
                            const pros = row.pros ? row.pros.split(',').map((item:string) => item.trim()).filter(Boolean) : [];
                            const cons = row.cons ? row.cons.split(',').map((item:string) => item.trim()).filter(Boolean) : [];
                            const features = [
                                ...pros.map((text:string) => ({ type: "pro", text })),
                                ...cons.map((text:string) => ({ type: "con", text }))
                            ];
                            const isExpanded = !!expandedCards[index];
                            const hasExtra = features.length > 3;
                            const gradientColor = index % 2 === 0 ? "#FFCECE" : "#ffffff";
                            const overlayGradient = `linear-gradient(180deg, rgba(255,255,255,0) 0%, ${gradientColor} 80%)`;
                            const toggleCard = () => setExpandedCards(prev => ({...prev, [index]: !prev[index]}));

                            const featuresList = (
                                <div className="position-relative">
                                    <div style={hasExtra && !isExpanded ? {maxHeight: "150px", overflow: "hidden"} : {}}>
                                        {features.map((feature:any, featureIndex:number) => (
                                            <div key={featureIndex} className="d-flex justify-start mb-3">
                                                <FontAwesomeIcon
                                                    icon={feature.type === "pro" ? "circle-check" : "circle-xmark"}
                                                    className={`${feature.type === "pro" ? "text-success" : "text-danger"} pt-1 me-2`}
                                                />
                                                <span className="text-start">{feature.text}</span>
                                            </div>
                                        ))}
                                    </div>
                                    {!isExpanded && hasExtra && (
                                        <div className="position-absolute start-0 bottom-0 w-100" style={{height: "60px", background: overlayGradient}} />
                                    )}
                                </div>
                            );

                            return index % 2 === 0 ?
                            <div className="col-lg-3 wow slideInUp mb-4 position-relative" data-wow-delay="0.6s" key={index}>
                                {row.popular && <span className="position-absolute top-0 start-100 badge rounded-end bg-success z-3 p-2" style={{margin:"10px -70px"}}>
                                    <FontAwesomeIcon icon="star" className="text-warning me-2 align-middle"/>
                                    پرطرفدار
                                    <span className="visually-hidden">پرطرفدار</span>
                                </span>}

                                <div className="rounded" style={{backgroundColor:"#FFCECE"}}>
                                    <div className="border-bottom py-4 px-4 mb-4">
                                        <h4 className="text-danger mb-2">{row.name}</h4>
                                        <small className="text-uppercase">{row.note}</small>
                                    </div>
                                    <div className="p-4 pt-0 text-end">
                                        {row.rial_price == 0 ? <h1 className="display-6 mb-3 text-end">رایگان</h1> :
                                            <>
                                                <h3 className="display-6 mb-3 text-end">
                                                    {row.rial_sale_price ? <><span className="text-decoration-line-through fs-3 fw-light">{fa_currency(+row.rial_price)}<small className="align-bottom" style={{fontSize: "16px", lineHeight: "40px"}}>تومان</small></span><br /> {fa_currency(+row.rial_sale_price)}</> : fa_currency(+row.rial_price)}
                                                    <small className="align-bottom" style={{fontSize: "16px", lineHeight: "40px"}}>تومان</small>
                                                </h3>
                                                <h3 className="display-7 mb-3 text-end">
                                                    {row.dollar_sale_price ? <><span className="text-decoration-line-through fs-4 fw-light">{+row.dollar_price}</span> {+row.dollar_sale_price}</> : row.dollar_price}
                                                    <small className="align-bottom" style={{fontSize: "16px", lineHeight: "26px"}}> تتر</small>
                                                </h3>
                                            </>
                                        }
                                        {featuresList}
                                        {hasExtra && <button type="button" className="btn btn-link text-danger px-0 mt-2" onClick={toggleCard}>{isExpanded ? "بستن" : "توضیحات بیشتر"}</button>}
                                        <Link to="/panel/package" className="btn btn-danger py-2 px-4 mt-4 d-block">{row.rial_price === '0' ? "ثبت نام رایگان" : "سفارش"}</Link>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="col-lg-3 wow slideInUp mb-4 position-relative" data-wow-delay="0.3s" key={index}>
                                {row.popular && <span className="position-absolute top-0 start-100 badge rounded-end bg-success z-3 p-2" style={{margin:"10px -70px"}}>
                                    <FontAwesomeIcon icon="star" className="text-warning me-2 align-middle"/>
                                    پرطرفدار
                                    <span className="visually-hidden">پرطرفدار</span>
                                </span>}
                                <div className="bg-white rounded shadow position-relative" style={{zIndex: 1}}>
                                    <div className="border-bottom py-4 px-4 mb-4">
                                        <h4 className="text-danger mb-2">{row.name}</h4>
                                        <small className="text-uppercase">{row.note}</small>
                                    </div>
                                    <div className="p-4 pt-0 text-end">
                                        {row.rial_price == 0 ? <h1 className="display-6 mb-3 text-end">رایگان</h1> :
                                            <>
                                                <h3 className="display-6 mb-3 text-end">
                                                    {row.rial_sale_price ? <><span className="text-decoration-line-through fs-3 fw-light">{fa_currency(+row.rial_price)}<small className="align-bottom" style={{fontSize: "16px", lineHeight: "40px"}}>تومان</small></span><br /> {fa_currency(+row.rial_sale_price)}</> : fa_currency(+row.rial_price)}
                                                    <small className="align-bottom" style={{fontSize: "16px", lineHeight: "40px"}}>تومان</small>
                                                </h3>
                                                <h3 className="display-7 mb-3 text-end">
                                                    {row.dollar_sale_price ? <><span className="text-decoration-line-through fs-4 fw-light">{+row.dollar_price}</span> {+row.dollar_sale_price}</> : row.dollar_price}
                                                    <small className="align-bottom" style={{fontSize: "16px", lineHeight: "26px"}}> تتر</small>
                                                </h3>
                                            </>
                                        }
                                        {featuresList}
                                        {hasExtra && <button type="button" className="btn btn-link text-danger px-0 mt-2" onClick={toggleCard}>{isExpanded ? "بستن" : "توضیحات بیشتر"}</button>}
                                        <Link to="/panel/package" className="btn btn-danger py-2 px-4 mt-4 d-block">{row.rial_price === '0' ? "ثبت نام رایگان" : "سفارش"}</Link>
                                    </div>
                                </div>
                            </div>;
                        })()
                    })}
                </div>
            </div>
        </div>
     );
}

export default Price;
